<template>
    <div class="registration-step-indicator-wrapper">
        <div class="registration-step-indicator">
            <a v-for="item in steps" :key="item.key" :href="(item.type != 'separator' && stepCompleted[item.key] && !disableLinks ? item.href : null)">
                <span :class="{step: item.type != 'separator', separator: item.type == 'separator', active: item.key == step}">
                    <i v-if="item.type != 'separator' && stepCompleted[item.key]" class="material-icons check">check_circle</i>
                    <custom-icon class="step-icon" :name="item.icon" :active="item.key == step"></custom-icon>
                    <span v-if="item.type != 'separator'">{{ $t('registration.step-' + item.key) }}</span>
                </span>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            step: String,
            disableLinks: String | Boolean,
        },
        data() {
            return {
                steps: [
                    {
                        key: 'profile',
                        icon: 'person_outline',
                        href: '/registration/fill-profile'
                    },
                    {
                        key: 'separator1',
                        type: 'separator',
                        icon: 'arrow_forward'
                    },
                    {
                        key: 'entity',
                        icon: 'business',
                        href: '/registration/entity-infos'
                    },
                    {
                        key: 'separator2',
                        type: 'separator',
                        icon: 'arrow_forward'
                    },
                    {
                        key: 'subscription',
                        icon: 'payment',
                        href: '/registration/payment'
                    },
                ],
                stepCompleted: {
                    profile: false,
                    entity: false,
                    subscription: false,
                }
            }
        },
        mounted() {
            var done = false;
            this.steps.forEach(s => {
                if (done) {
                    this.stepCompleted[s.key] = false;
                } else if (s.key == this.step) {
                    this.stepCompleted[s.key] = false;
                    done = true;
                } else {
                    this.stepCompleted[s.key] = true;
                }
            });
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/registration/StepIndicatorComponent.vue